<template>
  <div
    class="k-layout"
    ref="layout"
    v-bind="$attrs"
    v-on="$listeners"
    :style="gridStyles"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'KLayout',
  inheritAttrs: false,
  props: {
    gap: { 
      type: String, 
      default: '2px' 
    },
    alignCenter: { 
      type: Boolean, 
      default: false 
    },
    cols: {
      type: Number,
      default: 12
    },
    responsive: {
      type: String,
      default: ""
    }
  },
  watch: {
    responsive(newVal, oldVal) {
      if (newVal !== oldVal) {
        if (newVal != "") {
          this.addEventListener();
        } else {
          this.removeEventListener();
        }
      }
    }
  },
  data () {
    return {
      elementWidth: 0,
      eventListenerAdded: false
    }
  },
  mounted () {
    this.addEventListener();
  },
  beforeDestroy () {
    this.removeEventListener();
  },
  methods: {
    addEventListener() {
      if (this.responsive != "") {
        if (!this.eventListenerAdded) {
          this.elementWidth = this.$refs.layout.clientWidth;
          window.addEventListener("resize", this.onResize);
          this.eventListenerAdded = true;
        }
      }
    },
    removeEventListener() {
      if (this.eventListenerAdded) {
        window.removeEventListener("resize", this.onResize);
        this.eventListenerAdded = false;
      }
    },
    onResize () {
      if (this.responsive == "") return;

      if (this.$refs.layout) {
        var layoutWidth = this.$refs.layout.clientWidth;
        if (layoutWidth !== this.elementWidth) {
          this.elementWidth = layoutWidth;
        }
      }
    }
  },
  computed: {
    gridStyles() {
      var columns = `repeat(${this.cols}, minmax(0, 1fr))`;
      if (this.responsive != "") {
        if (this.elementWidth > 0 && this.elementWidth < parseInt(this.responsive,10)) {
          columns = '1fr';
        }
      }

      return {
        display: 'grid',
        gridTemplateColumns: columns,
        gap: this.gap,
        alignItems: this.alignCenter ? 'center' : 'stretch',
      };
    }
  }
};
</script>

<style scoped>
.k-layout {
  width: 100%;
  box-sizing: border-box;
}
</style>